import { createSelector } from "reselect";
import { get, sortBy } from "lodash";

import { getPageContent } from "shared/selectors/base";

// eslint-disable-next-line import/prefer-default-export
export const getExternalSalesPartners = createSelector(
  [getPageContent],
  pageContent =>
    sortBy(get(pageContent, "external_sales_partners", []), ["position", "id"])
);
